
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.502 1.947l-1.45-1.45a1.7 1.7 0 00-2.403 0L.862 11.285a.477.477 0 00-.13.246l-.724 3.915a.469.469 0 00.546.546l3.915-.725a.478.478 0 00.246-.13L15.502 4.35a1.698 1.698 0 000-2.403zm-14.448 13l.438-2.369 1.93 1.93-2.368.438zm3.33-.804l-2.527-2.527 9.225-9.226 2.527 2.527-9.226 9.226zM14.838 3.687l-.567.567-2.527-2.527.567-.567a.762.762 0 011.077 0l1.45 1.45a.761.761 0 010 1.077z"}})])
          )
        }
      }
    